export default function podcastsInit() {
    const players = document.querySelectorAll('.podcast-player');

    players.forEach(player => {
        const podcastId = player.getAttribute('data-podcast');
        const audio = document.getElementById(podcastId);
        const button = player.querySelector('.podcast-play-btn');
        const playIcon = button.querySelector('.play-icon');
        const pauseIcon = button.querySelector('.pause-icon');
        const progressBar = player.querySelector('.podcast-progress');
        const currentTimeSpan = player.querySelector('.current-time');
        const durationSpan = player.querySelector('.duration');

        if (!audio) return;

        // Récupérer les informations du podcast
        const podcastItem = player.closest('.podcast-item');
        const podcastTitle = podcastItem.querySelector('.podcast-title')?.textContent || 'Podcast';
        const podcastImage = podcastItem.querySelector('.podcast-visu img')?.src || '';
        const podcastType = podcastItem.classList.contains('podcast-us') ? 'US' : 'FR';

        // État initial : afficher play, cacher pause
        pauseIcon.style.display = 'none';

        // Formater le temps en HH:MM:SS ou MM:SS
        const formatTime = (seconds) => {
            if (isNaN(seconds) || seconds === 0) return '0:00';

            const hours = Math.floor(seconds / 3600);
            const mins = Math.floor((seconds % 3600) / 60);
            const secs = Math.floor(seconds % 60);

            if (hours > 0) {
                return `${hours}:${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
            } else {
                return `${mins}:${secs.toString().padStart(2, '0')}`;
            }
        };

        // Configurer la Media Session API
        const setupMediaSession = () => {
            if ('mediaSession' in navigator) {
                navigator.mediaSession.metadata = new MediaMetadata({
                    title: podcastTitle,
                    artist: 'Abcdr du Son',
                    album: `Podcast ${podcastType}`,
                    artwork: [
                        { src: podcastImage, sizes: '512x512', type: 'image/jpeg' }
                    ]
                });

                // Gestionnaires d'actions
                navigator.mediaSession.setActionHandler('play', () => {
                    audio.play();
                    player.classList.add('playing');
                    playIcon.style.display = 'none';
                    pauseIcon.style.display = 'block';
                });

                navigator.mediaSession.setActionHandler('pause', () => {
                    audio.pause();
                    player.classList.remove('playing');
                    playIcon.style.display = 'block';
                    pauseIcon.style.display = 'none';
                });

                navigator.mediaSession.setActionHandler('seekbackward', (details) => {
                    audio.currentTime = Math.max(audio.currentTime - (details.seekOffset || 10), 0);
                });

                navigator.mediaSession.setActionHandler('seekforward', (details) => {
                    audio.currentTime = Math.min(audio.currentTime + (details.seekOffset || 10), audio.duration);
                });

                navigator.mediaSession.setActionHandler('seekto', (details) => {
                    if (details.seekTime) {
                        audio.currentTime = details.seekTime;
                    }
                });
            }
        };

        // Mettre à jour la position dans la Media Session
        const updatePositionState = () => {
            if ('mediaSession' in navigator && 'setPositionState' in navigator.mediaSession) {
                if (audio.duration && !isNaN(audio.duration) && audio.duration !== Infinity) {
                    navigator.mediaSession.setPositionState({
                        duration: audio.duration,
                        playbackRate: audio.playbackRate,
                        position: audio.currentTime
                    });
                }
            }
        };

        // Fonction pour initialiser la durée
        const initDuration = () => {
            if (audio.duration && !isNaN(audio.duration) && audio.duration !== Infinity) {
                durationSpan.textContent = formatTime(audio.duration);
                progressBar.max = audio.duration;
            }
        };

        // Essayer plusieurs événements pour charger la durée
        audio.addEventListener('loadedmetadata', initDuration);
        audio.addEventListener('durationchange', initDuration);
        audio.addEventListener('canplay', initDuration);

        // Si les métadonnées sont déjà chargées
        if (audio.readyState > 0) {
            initDuration();
        }

        // Mettre à jour le temps et la barre de progression pendant la lecture
        audio.addEventListener('timeupdate', () => {
            currentTimeSpan.textContent = formatTime(audio.currentTime);
            progressBar.value = audio.currentTime;
            updatePositionState();
        });

        // Gérer le clic sur le bouton
        button.addEventListener('click', () => {
            if (audio.paused) {
                // Mettre en pause tous les autres podcasts
                document.querySelectorAll('audio').forEach(otherAudio => {
                    if (otherAudio !== audio && !otherAudio.paused) {
                        otherAudio.pause();
                    }
                });

                // Réinitialiser tous les autres players
                document.querySelectorAll('.podcast-player').forEach(otherPlayer => {
                    if (otherPlayer !== player) {
                        otherPlayer.classList.remove('playing');
                        const otherBtn = otherPlayer.querySelector('.podcast-play-btn');
                        otherBtn.querySelector('.play-icon').style.display = 'block';
                        otherBtn.querySelector('.pause-icon').style.display = 'none';
                    }
                });

                audio.play();
                player.classList.add('playing');
                playIcon.style.display = 'none';
                pauseIcon.style.display = 'block';
                setupMediaSession();
                updatePositionState();
            } else {
                audio.pause();
                player.classList.remove('playing');
                playIcon.style.display = 'block';
                pauseIcon.style.display = 'none';
            }
        });

        // Gérer le déplacement de la barre de progression
        progressBar.addEventListener('input', () => {
            audio.currentTime = progressBar.value;
        });

        // Gérer la fin de lecture
        audio.addEventListener('ended', () => {
            player.classList.remove('playing');
            playIcon.style.display = 'block';
            pauseIcon.style.display = 'none';
            progressBar.value = 0;
            currentTimeSpan.textContent = '0:00';
        });
    });
}
